module.exports = __webpack_public_path__ + "img/digitable-platforme.c983fab1.png";